export const getFormattedDate = (d) => {
  const date = new Date(d);
  const formattedDate = date.toLocaleDateString("ar");

  return formattedDate;
};
